// AI Chat Attachment Upload Client

import baseUrl from '../../../config';
import { routes } from '../../../services/api/routes';

export const OFFLINE = 'OFFLINE';

const ERROR_MESSAGES = {
  UNSUPPORTED_IMAGE_TYPE: 'Only PNG, JPEG, WebP and GIF images can be attached.',
  IMAGE_TOO_LARGE: 'Image is too large. Maximum size is 5MB.',
  INVALID_IMAGE: 'That file is not a valid image.',
  FORBIDDEN: 'Image attachments are not available on your plan.',
  NOT_OWNER: 'You do not have access to this site.',
  SITE_DOES_NOT_EXISTS: 'This site no longer exists.',
  TOO_MANY_REQUESTS: 'Too many uploads. Please wait a moment and try again.'
};

const offlineError = () => {
  const error = new Error('No connection. This will retry when you are back online.');
  error.code = OFFLINE;
  return error;
};

export async function uploadAttachment(domain, dataUrl) {
  const accessToken = localStorage.getItem('token');

  let response;
  try {
    response = await fetch(`${baseUrl}${routes.editor.aiChatAttachment}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ domain, dataUrl })
    });
  } catch (err) {
    // fetch rejects only when the request never reached the server, so this is
    // the connection dropping rather than the server refusing.
    throw offlineError();
  }

  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(ERROR_MESSAGES[data.code] || data.error?.message || response.statusText);
  }

  return { url: data.url, src: data.src, width: data.width, height: data.height };
}
